import API from "../configs/axiosInstance";

const upsertAssetFrequency = (data = {}) => {
  return API({
    url: `/account-service/v1/task-schedulers`,
    method: "PUT",
    data,
  });
};

const assetFrequencyService = {
  upsertAssetFrequency,
};

export default assetFrequencyService;
